import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const EventoCTAFinal = () => {
  return (
    <section className="bg-[#112711]">
      <div className="container-narrow py-20 sm:py-28 text-center">
        <span className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 bg-[#1F4A33] text-[#D1F8E2] text-[11px] font-semibold tracking-[0.1em] uppercase ring-1 ring-[#4BD084]/40">
          <span className="inline-flex h-1.5 w-1.5 rounded-full bg-[#4BD084]" />
          Seleção de parceiros · aplicação caso a caso
        </span>

        <h2
          className="mt-6 text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-[1.1] max-w-3xl mx-auto"
          style={{
            fontFamily:
              '"Playfair Display", Georgia, "Times New Roman", serif',
            letterSpacing: "-0.02em",
          }}
        >
          Divulgue um produto exclusivo da Allu. Aplicação revisada caso a
          caso.
        </h2>

        <div className="mt-10">
          <Link
            to="/evento/aplicar"
            className="inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm h-12 sm:h-[52px] px-8 bg-[#4BD084] text-[#112711] hover:bg-[#5fdc94] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#112711] focus-visible:ring-[#4BD084]"
          >
            Quero me candidatar
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <p className="mt-6 text-xs text-[#D1F8E2]/60">
          Para sócios de casa e assessores com carteira acima de R$ 50 milhões.
        </p>
      </div>
    </section>
  );
};
